<template>
  <div class="random-featured">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    raised: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newRaised: 0,
    }
  },
  mounted() {
    this.showRandom(Array.from(this.$el.children))
  },

  methods: {
    showRandom(featured) {
      console.log('featured: ' + featured.length)
      var temp
      if (featured.length == 1) {
        temp = featured[0]
      } else {
        temp = featured[Math.floor(Math.random() * featured.length) - 1]
      }
      temp.style.display = 'block'
    },
  },
}
</script>
